export enum LoadingMessage {
    CONNECTING = "Connecting...",
    PREPARING_APP = "Preparing your applications...",
    RESERVING_SESSION = "Reserving your session...",
    RESIZING = "Resizing...",
}
